'use strict';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var delay = require('../promise/delay.js');
var DEFAULT_DELAY = 0;
var DEFAULT_RETRIES = Number.POSITIVE_INFINITY;
function retry(func, _options) {
    return _retry.apply(this, arguments);
}
function _retry() {
    _retry = _async_to_generator(function(func, _options) {
        var delay$1, retries, signal, _options_delay, _options_retries, error, attempts, err, currentDelay;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof _options === 'number') {
                        delay$1 = DEFAULT_DELAY;
                        retries = _options;
                        signal = undefined;
                    } else {
                        ;
                        delay$1 = (_options_delay = _options === null || _options === void 0 ? void 0 : _options.delay) !== null && _options_delay !== void 0 ? _options_delay : DEFAULT_DELAY;
                        ;
                        retries = (_options_retries = _options === null || _options === void 0 ? void 0 : _options.retries) !== null && _options_retries !== void 0 ? _options_retries : DEFAULT_RETRIES;
                        signal = _options === null || _options === void 0 ? void 0 : _options.signal;
                    }
                    attempts = 0;
                    _state.label = 1;
                case 1:
                    if (!(attempts < retries)) return [
                        3,
                        7
                    ];
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                        throw error !== null && error !== void 0 ? error : new Error("The retry operation was aborted due to an abort signal.");
                    }
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        func()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    err = _state.sent();
                    error = err;
                    currentDelay = typeof delay$1 === 'function' ? delay$1(attempts) : delay$1;
                    return [
                        4,
                        delay.delay(currentDelay)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    attempts++;
                    return [
                        3,
                        1
                    ];
                case 7:
                    throw error;
            }
        });
    });
    return _retry.apply(this, arguments);
}
exports.retry = retry;
